import { render } from "./FaceIdTab.vue?vue&type=template&id=69641210"
import script from "./FaceIdTab.vue?vue&type=script&lang=js"
export * from "./FaceIdTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__